// extracted by mini-css-extract-plugin
export default {"editProfileInfo":"EOmdfBbj_vn7IAeOYJAV","textRed":"qcWqJm_t_TGYWmhar1f9"};